import { TrackingLabel } from '../../components/root/contexts/TrackingContext/TrackingConstants'
import type { Project } from '../../types/Project'
import type { Quantity } from '../../types/Inventory'

/**
 * Tracks add to cart events for all projects
 *
 * @param projects - Array of projects to track
 * @param worksData - Map of work IDs to their quantity data
 * @param trackAddToCart - Tracking function to call for each project
 */
export function trackProjectsAddToCart(
  projects: Project[],
  worksData: Record<string, { inputQuantity?: Quantity; totalQuantity?: number }>,
  trackAddToCart: (
    label: TrackingLabel,
    productKey: string,
    productVersion: number,
    lowestPriceAttributes: Record<string, string>,
    mpvId: string,
    productName: string,
    quantity: Quantity,
  ) => void,
): void {
  projects.forEach((project) => {
    const { workId, productKey, productVersion, productName, mpvId, lowestPriceAttributes } = project
    const { inputQuantity } = worksData[workId] ?? {}

    if (!inputQuantity) {
      return
    }

    trackAddToCart(TrackingLabel.ADD_TO_CART_SUCCESS, productKey, productVersion, lowestPriceAttributes, mpvId, productName, inputQuantity)
  })
}
